import { createReducer, on } from '@ngrx/store';
import { cloneDeep } from 'lodash';
import { ReportViewActions } from './view.actions';
import {
  ReportViewState,
  initialReportViewState,
  reportViewState
} from './view.state';

export const reportViewReducer = createReducer(
  reportViewState,
  on(
    ReportViewActions.reset,
    (): ReportViewState => cloneDeep(initialReportViewState)
  ),
  on(
    ReportViewActions.setCategoryLoading,
    (state, { loading }): ReportViewState => ({
      ...state,
      loading: {
        ...state.loading,
        category: loading
      }
    })
  ),
  on(
    ReportViewActions.setReportTypeLoading,
    (state, { loading }): ReportViewState => ({
      ...state,
      loading: {
        ...state.loading,
        reportType: loading
      }
    })
  ),
  on(
    ReportViewActions.setReportType,
    (state, { reportType }): ReportViewState => ({ ...state, reportType })
  ),
  on(
    ReportViewActions.setCategory,
    (state, category): ReportViewState => ({ ...state, category })
  ),
  on(
    ReportViewActions.setCategoryPartial,
    (state, { results = [], count }): ReportViewState => ({
      ...state,
      category: {
        count,
        results: [...(state.category.results ?? []), ...results]
      }
    })
  ),
  on(
    ReportViewActions.setSelectedCategory,
    (state, { selectedCategory }): ReportViewState => ({
      ...state,
      selectedCategory
    })
  ),
  on(
    ReportViewActions.setReportTypeDetail,
    (state, { reportType }): ReportViewState => ({
      ...state,
      reportTypeDetail: reportType
    })
  ),
  on(
    ReportViewActions.setKeyword,
    (state, { keyword }): ReportViewState => ({
      ...state,
      keyword: keyword
    })
  )
);
